import { render } from "./UserPhotoUpload.vue?vue&type=template&id=a66a8f5c"
import script from "./UserPhotoUpload.vue?vue&type=script&lang=js"
export * from "./UserPhotoUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__